import { Flex, Menu, MenuButton, MenuItem } from "@aws-amplify/ui-react"
import React from "react"
import styled from "styled-components"

const ProfileImg = styled.img`
  width: 34px;
  height: 34px;
  font-size: 14px;
  border-radius: 50%;
  overflow: hidden;
`

const ProfileHeader = ({ signOut }) => {
  return (
    <Flex>
      <Menu
        menuAlign="end"
        trigger={(
          <MenuButton variation="menu">
            <Flex className="header-avatar">
              <ProfileImg alt="avatar" src="https://i.pravatar.cc/150?img=3" />
            </Flex>
          </MenuButton>
        )}
      >
        <MenuItem> Profile</MenuItem>
        <MenuItem>Settings</MenuItem>
        <MenuItem onClick={signOut}>Logout</MenuItem>
      </Menu>
    </Flex>
  )
}

export default ProfileHeader
